import React, {useMemo, useContext} from "react"
import getAccordionContent from "../components/bikeDetails/AccordionContent"
import CustomerQuestionsSection from "../components/bikeDetails/CustomerQuestionsSection"
import Typography from "../components/reusable/Typography/Typography"
import useBookShowroom from "./useBookShowroom"
import AnalyticsContext from "../context/AnalyticsContext"
import {gaCategories, gaEvents} from "../config/googleAnalytics/events"
import DataContext from "../context/DataContext"
import {formatStrapiData} from "../strapi/strapiHelpers"

function useGetAccordionContent(bike, isAccessory, isMobile, selectedVariation, questions, t) {
	const openShowroomBookingModal = useBookShowroom()
	const {reactGA} = useContext(AnalyticsContext)
	const {pageProps: {strapiContent}} = useContext(DataContext)
	const service_partners = strapiContent?.data?.service_partners || []
	const servicePartners = formatStrapiData(service_partners, ["name", "address", "city", "phone", "email", "brands", "zip", "lat", "lng"])

	const handleClick = () => {
		reactGA?.event({
			categories: gaCategories.testDrive,
			action: gaEvents.testDriveCTA,
			label: `Test Drive for ${bike.name} clicked on PDP`,
			nonInteraction: false
		})
		openShowroomBookingModal()
	}

	const accordionContentOrigin = useMemo(() => getAccordionContent(bike, isAccessory, t, handleClick, servicePartners), [
		bike,
		isAccessory,
		isMobile
	])

	const customerQuestionsContent = {
		title: `${t("customers_questions")} ${questions?.length ? `(${questions?.length})` : ""} `,
		slug: t("customers_questions"),
		content: (
			<CustomerQuestionsSection
				selectedVariation={selectedVariation}
				bike={bike}
				questions={questions}
			/>
		),
		titleContent: (
			<Typography semanticTag="h3"
				className="mb-0"
				variant={"heading1Black"}>
				{`${t("customers_questions")} ${questions?.length ? `(${questions?.length})` : ""}`}
			</Typography>
		)
	}

	const accordionContent = [...accordionContentOrigin, customerQuestionsContent]

	return {accordionContent}
}

export default useGetAccordionContent
